import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { gradientHero } from '../../theme';
import PublicNavBar from '../../components/PublicNavBar';
import PortalFooter from '../../components/PortalFooter';

const RegisterPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f8f9fa', display: 'flex', flexDirection: 'column' }}>
      <PublicNavBar />

      <Box sx={{ background: gradientHero, color: '#fff', py: 6, textAlign: 'center' }}>
        <Container maxWidth="lg">
          <Typography variant="h3" component="h1" sx={{ fontWeight: 'bold', mb: 2 }}>
            Konto erstellen
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.9 }}>
            Wählen Sie, wie Sie sich registrieren möchten
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg">
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          minHeight="50vh"
          py={8}
        >
          <Grid container spacing={4}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Card sx={{ height: '100%', boxShadow: 2, cursor: 'pointer', transition: 'all 0.3s ease', '&:hover': { boxShadow: 4, transform: 'translateY(-4px)' } }}>
                <CardContent sx={{ textAlign: 'center', py: 6 }}>
                  <Typography variant="h3" sx={{ mb: 2 }}>
                    👤
                  </Typography>
                  <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
                    Auftraggeber
                  </Typography>
                  <Typography color="textSecondary" sx={{ mb: 4 }}>
                    Sie suchen nach geprüften Call Center Dienstleistern? Registrieren Sie sich als Auftraggeber und erhalten Sie schnell passende Angebote.
                  </Typography>
                  <Button
                    variant="contained"
                    size="large"
                    fullWidth
                    onClick={() => navigate('/register/customer')}
                  >
                    Als Auftraggeber registrieren
                  </Button>
                </CardContent>
              </Card>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Card sx={{ height: '100%', boxShadow: 2, cursor: 'pointer', transition: 'all 0.3s ease', '&:hover': { boxShadow: 4, transform: 'translateY(-4px)' } }}>
                <CardContent sx={{ textAlign: 'center', py: 6 }}>
                  <Typography variant="h3" sx={{ mb: 2 }}>
                    🏢
                  </Typography>
                  <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
                    Call Center Dienstleister
                  </Typography>
                  <Typography color="textSecondary" sx={{ mb: 4 }}>
                    Sie sind ein geprüftes Call Center? Registrieren Sie sich als Dienstleister und erhalten Sie Zugriff auf neue Geschäftsmöglichkeiten.
                  </Typography>
                  <Button
                    variant="contained"
                    size="large"
                    fullWidth
                    onClick={() => navigate('/register/contractor')}
                  >
                    Als Dienstleister registrieren
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Box sx={{ textAlign: 'center', mt: 6 }}>
            <Typography color="textSecondary">
              Haben Sie bereits ein Konto?{' '}
              <Link to="/login" style={{ textDecoration: 'none', color: '#667eea', fontWeight: 600 }}>
                Hier anmelden
              </Link>
            </Typography>
          </Box>
        </Box>
      </Container>

      <PortalFooter />
    </Box>
  );
};

export default RegisterPage;
